import type { IWSTask } from './index'

type TaskStatusChangedHandler = (payload: IWSTask) => void

const projectTaskStatusChangedHandlers = new Set<TaskStatusChangedHandler>()
const textToVideoTaskStatusChangedHandlers = new Set<TaskStatusChangedHandler>()

export const onProjectTaskStatusChanged = (handler: TaskStatusChangedHandler) => {
  projectTaskStatusChangedHandlers.add(handler)
  return () => {
    projectTaskStatusChangedHandlers.delete(handler)
  }
}

export const emitProjectTaskStatusChanged = (payload: IWSTask) => {
  projectTaskStatusChangedHandlers.forEach(handler => handler(payload))
}

export const onTextToVideoTaskStatusChanged = (handler: TaskStatusChangedHandler) => {
  textToVideoTaskStatusChangedHandlers.add(handler)
  return () => {
    textToVideoTaskStatusChangedHandlers.delete(handler)
  }
}

export const emitTextToVideoTaskStatusChanged = (payload: IWSTask) => {
  textToVideoTaskStatusChangedHandlers.forEach(handler => handler(payload))
}
